module.exports = __webpack_public_path__ + "img/sb.1a16978a.svg";